export default __webpack_public_path__ + "static/vision-mssion-values-hero-25440fe93a713bc85e08cd4c1d00d902.jpg";